// The light elevation (the approved Hero design) is a soft dark-tinted drop;
// that tint is invisible on the dark page, so dark mode uses the heavier
// flipping shadow token instead.
const LIGHT_POPOVER_SHADOW =
  '0 20px 48px -16px rgba(17, 19, 26, 0.26), 0 6px 16px -8px rgba(17, 19, 26, 0.12)';

const LIST_MAX_HEIGHT = '360px';

export const wrapperStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '344px',
  maxWidth: 'calc(100vw - 16px)',
  maxHeight: 'calc(100vh - 16px)',
  backgroundColor: palette.background.paper,
  border: `1px solid ${palette.border.default}`,
  borderRadius: '16px',
  boxShadow: palette.mode === 'dark' ? palette.shadow.l : LIGHT_POPOVER_SHADOW,
  overflow: 'hidden',
});

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  padding: '8px 14px 12px',
};

export const listEyebrowStyles = ({ palette }) => ({
  display: 'block',
  padding: '10px 6px 6px',
  textTransform: 'uppercase',
  color: palette.text.secondary,
});

export const scrollAreaStyles = {
  flex: '1 1 auto',
  minHeight: 0,
  maxHeight: LIST_MAX_HEIGHT,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const emptyStyles = ({ palette }) => ({
  display: 'block',
  padding: '20px 12px',
  textAlign: 'center',
  color: palette.text.secondary,
});

export const skeletonStyles = {
  margin: '8px 10px',
  borderRadius: '10px',
};

export const footerStyles = ({ palette }) => ({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  gap: '8px',
  padding: '12px 22px',
  borderTop: `1px solid ${palette.divider}`,
  backgroundColor: palette.background.default,
});

export const getFooterSwatchStyles = color => ({
  width: '8px',
  height: '8px',
  borderRadius: '2px',
  backgroundColor: color,
  flexShrink: 0,
});

export const footerLabelStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

// `deep` reads on the light footer; on the dark footer use the brighter
// `strong` so the next-milestone name stays legible for any milestone hue.
export const getFooterNextStyles =
  ({ strong, deep }) =>
  ({ palette }) => ({
    color: palette.mode === 'dark' ? strong : deep,
  });
